import { CallToActionStyle, ICallToAction } from '~/lib/data-contract';
import { Button, ButtonProps } from '~/shared/components/Button/Button';
import { CallToAction } from '~/shared/components/CallToAction/CallToAction';
import Link from '~/shared/components/Link/Link';

export type DynamicCallToActionStyle = Extract<CallToActionStyle, 'arrow' | 'button'>;

export type DynamicCallToActionProps = {
	callToAction: ICallToAction;
	defaultStyle: DynamicCallToActionStyle;
	buttonVariant?: ButtonProps['variant'];
	shade?: 'dark' | 'light';
	className?: string;
};

export const DynamicCallToAction = ({ callToAction, defaultStyle, buttonVariant, shade, className }: DynamicCallToActionProps) => {
	const { url, text, ...callToActionProps } = callToAction;

	if ((callToAction.style === 'default' && defaultStyle === 'button') || callToAction.style === 'button') {
		return (
			<Button
				as={Link}
				href={url}
				className={className}
				shade={shade}
				variant={buttonVariant}
				title={callToActionProps.title}
				target={callToActionProps.target}
			>
				{text}
			</Button>
		);
	} else {
		return (
			<CallToAction
				className={className}
				shade={shade}
				{...callToAction}
			/>
		);
	}
};
